/**
 * ET-Vergleich auf Produktseiten: liest die Werks-ET-Spanne, die der
 * Fitment-Konfigurator vor dem Redirect in sessionStorage("zr_fitment")
 * abgelegt hat (siehe fitment-configurator.js doLookup() und
 * zr-fitment-oe.js), und vergleicht sie mit der Produkt-ET aus dem Metafeld
 * custom.einpresstiefe. Zeigt sich NUR, wenn:
 *   - Fahrzeugdaten vorhanden sind,
 *   - der Lochkreis von Produkt und Fahrzeug übereinstimmt (sonst irrelevant),
 *   - beide ET-Werte eindeutig sind (keine Mehrwert-Listen/Freitext).
 * Rechenweg (Versatz pro Seite / Spurweite) folgt derselben Formel wie
 * packages/shared/spurweite.ts im wawi-Backend: perSideMm = etReferenz - etProdukt.
 */
(function () {
  "use strict";

  function esc(s) {
    var div = document.createElement("div");
    div.textContent = s == null ? "" : String(s);
    return div.innerHTML;
  }

  function normalizeBolt(s) {
    return String(s || "")
      .replace(/,/g, ".")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function boltPatternMatches(vehicleBolt, vehicleRearBolt, productBoltRaw) {
    if (!productBoltRaw) return false;
    var candidates = normalizeBolt(productBoltRaw).split(" ").filter(Boolean);
    if (vehicleBolt && candidates.indexOf(normalizeBolt(vehicleBolt)) !== -1) return true;
    // Selten, aber moeglich (z. B. manche Transporter): eigener Lochkreis hinten.
    if (vehicleRearBolt && candidates.indexOf(normalizeBolt(vehicleRearBolt)) !== -1) return true;
    return false;
  }

  /** Liefert die ET nur, wenn der Text GENAU einen Zahlenwert beschreibt. */
  function parseSingleEt(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (s === "") return null;
    // Mehrwert-Listen ("ET20/ET23/ET25", "ET17 - Nicht verfügbar/...") sind
    // nicht eindeutig einem Rad zuzuordnen -> keine Anzeige statt Raten.
    if (s.indexOf("/") !== -1) return null;
    var m = s.replace(",", ".").match(/-?\d+(\.\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0]);
    return Number.isFinite(n) ? n : null;
  }

  // Erfasst ET-Werte von VORNE und HINTEN — bei Staggered-Fitment (z. B.
  // viele Performance-Modelle) hat die Hinterachse ein eigenes Maß, das sonst
  // aus der Spanne faellt und ein Aftermarket-Rad faelschlich als "im
  // Werksrahmen" durchgehen liesse.
  function vehicleEtRange(stockWheels) {
    var values = [];
    (stockWheels || []).forEach(function (w) {
      [w.front, w.rear].forEach(function (side) {
        if (side && typeof side.rimOffset === "number" && Number.isFinite(side.rimOffset)) {
          values.push(side.rimOffset);
        }
      });
    });
    if (!values.length) return null;
    return { min: Math.min.apply(null, values), max: Math.max.apply(null, values) };
  }

  function render(box, vehicleLabel, range, productEt, contactHref) {
    var withinRange = productEt >= range.min && productEt <= range.max;
    var rangeLabel =
      range.min === range.max ? "ET " + range.min : "ET " + range.min + "–" + range.max;

    var bodyHtml;
    var noteHtml;
    if (withinRange) {
      bodyHtml =
        '<p class="zr-et-compare__text">Diese Felge hat ET ' +
        esc(productEt) +
        " und liegt damit innerhalb der Werksspanne (" +
        esc(rangeLabel) +
        ") von " +
        esc(vehicleLabel) +
        ".</p>";
      noteHtml =
        '<p class="zr-et-compare__note">Maßgeblich ist immer die ABE/das Teilegutachten der jeweiligen Felge.</p>';
    } else {
      var referenceEt = productEt < range.min ? range.min : range.max;
      var perSideMm = referenceEt - productEt;
      var totalMm = Math.round(Math.abs(perSideMm) * 2 * 10) / 10;
      var perSideAbs = Math.round(Math.abs(perSideMm) * 10) / 10;
      var outward = perSideMm > 0;
      var direction = outward ? "weiter nach außen" : "weiter nach innen";
      // Eine abweichende ET aendert nichts am Lochkreis/an der Passung — das
      // Rad schraubt trotzdem an. Ohne diesen Satz liest sich "weicht ab" +
      // "steht weiter raus" leicht wie "passt nicht", dabei ist das bei
      // Aufruestungen der Normalfall im Felgenhandel.
      var reassurance = outward
        ? "Das ist bei Aufrüstungen üblich und ändert nichts an der Lochkreis-Passung, das Rad sitzt lediglich weiter außen. Bei stärkerem Überstand kann eine Radhausverbreiterung sinnvoll oder nötig werden."
        : "Das ist bei Aufrüstungen üblich und ändert nichts an der Lochkreis-Passung, das Rad sitzt lediglich weiter innen. Prüfen Sie bei stärkerer Abweichung die Freigängigkeit zu Bremse und Fahrwerk.";
      bodyHtml =
        '<p class="zr-et-compare__text">Diese Felge hat ET ' +
        esc(productEt) +
        " und weicht von der Werksspanne (" +
        esc(rangeLabel) +
        ") von " +
        esc(vehicleLabel) +
        " ab.</p>" +
        '<p class="zr-et-compare__text">Rechnerisch steht das Rad dadurch ca. ' +
        esc(perSideAbs) +
        " mm pro Seite " +
        direction +
        " (Spurweite gesamt ca. " +
        esc(totalMm) +
        " mm).</p>" +
        '<p class="zr-et-compare__text">' +
        reassurance +
        "</p>";
      noteHtml =
        '<p class="zr-et-compare__note">Maßgeblich ist immer die ABE/das Teilegutachten der jeweiligen Felge. ' +
        "Bei größerer Abweichung ggf. Distanzscheiben, Zentrierring oder Rücksprache mit einer Prüfstelle klären." +
        (contactHref
          ? ' <a class="zr-et-compare__contact" href="' +
            esc(contactHref) +
            '">Unsicher? Jetzt beraten lassen.</a>'
          : "") +
        "</p>";
    }

    box.innerHTML =
      '<div class="zr-et-compare__head">' +
      '<span class="zr-et-compare__eyebrow">ET-Vergleich zu Ihrem Fahrzeug</span>' +
      '<span class="zr-et-compare__badge ' +
      (withinRange ? "zr-et-compare__badge--ok" : "zr-et-compare__badge--check") +
      '">' +
      (withinRange ? "im Werksrahmen" : "weicht ab") +
      "</span>" +
      "</div>" +
      bodyHtml +
      noteHtml;

    box.hidden = false;
  }

  function init() {
    var box = document.querySelector("[data-zr-et-compare]");
    if (!box) return;

    var raw;
    try {
      raw = sessionStorage.getItem("zr_fitment");
    } catch (e) {
      return;
    }
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!data) return;
    // Aelterer sessionStorage-Eintrag vor der front/rear-Umstellung — siehe
    // zr-fitment-oe.js. vehicleEtRange() faende ohnehin nichts, aber der
    // Check macht das explizit statt sich auf den Nebeneffekt zu verlassen.
    if (data.schemaVersion !== 2) return;

    if (!boltPatternMatches(data.boltPattern, data.rearBoltPattern, box.dataset.productBoltPattern)) return;

    var range = vehicleEtRange(data.stockWheels);
    if (!range) return;

    var productEt = parseSingleEt(box.dataset.productEt);
    if (productEt == null) return;

    render(box, data.vehicle, range, productEt, box.dataset.contactHref);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
